<template>
	<div style="height: 90vh">
		<div style="height: 5rem">
			<v-toolbar flat class="elevation-0 transparent">
				<v-toolbar-title>Roles</v-toolbar-title>
				<v-spacer></v-spacer>
				<div>
					<v-radio-group v-model="filterOption" row hide-details>
						<v-radio
							v-for="option in filterOptions"
							:key="option.value"
							:label="option.text"
							:value="option.value"
						></v-radio>
					</v-radio-group>
				</div>
			</v-toolbar>
		</div>

		<div style="height: calc(100% - 5rem)">
			<roles-permissions-matrix
				:roles="filteredRoles"
				:permissions="permissions"
				@role:create="handleCreateRole"
				@role:duplicate="handleDuplicateRole"
				@role:delete="handleDeleteRole"
				@role:update="handleUpdateRole"
			></roles-permissions-matrix>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ACTION_NOTIFICATIONS_ERROR, STORE_NOTIFICATIONS_NAME } from '@/store_constants/notifications';
import RolesPermissionsMatrix from './components/RolesPermissionsMatrix.vue';
import {
	ACTION_CREATE_ROLE,
	ACTION_DELETE_ROLE,
	ACTION_UPDATE_ROLE,
	STATE_ALL_ROLES,
	STORE_ROLES_NAME
} from '@/store_constants/roles';
import { STATE_ALL_PERMISSONS, STORE_PERMISSIONS_NAME } from '@/store_constants/permissions';

export default {
	components: { RolesPermissionsMatrix },
	data() {
		return {
			filterOption: 'all',
			filterOptions: [
				{ value: 'all', text: 'Show all' },
				{ value: 'enabled', text: 'Show enabled' },
				{ value: 'disabled', text: 'Show disabled' }
			]
		};
	},
	computed: {
    ...mapState(STORE_PERMISSIONS_NAME, {
      permissions: STATE_ALL_PERMISSONS
    }),
    ...mapState(STORE_ROLES_NAME, {
      roles: STATE_ALL_ROLES
    }),
		filteredRoles() {
			switch (this.filterOption) {
				case 'enabled':
					return this.roles.filter(role => !role.disabled);
				case 'disabled':
					return this.roles.filter(role => role.disabled);
				default:
					return this.roles;
			}
		}
	},
	methods: {
		...mapActions(STORE_NOTIFICATIONS_NAME, {
			error: ACTION_NOTIFICATIONS_ERROR
		}),
		...mapActions(STORE_ROLES_NAME, {
			createRole: ACTION_CREATE_ROLE,
			updateRole: ACTION_UPDATE_ROLE,
			deleteRole: ACTION_DELETE_ROLE
		}),
		format(string) {
			const words = string.split('_');
			const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
			return formattedWords.join(' ');
		},
		handleCreateRole() {
			this.createRole({ name: 'New_role', description: '', permissions: [] });
		},
		handleDeleteRole(rolId) {
			this.deleteRole({ id: rolId });
		},
		handleDuplicateRole(rolId) {
			const roleToDuplicate = this.roles.find(role => role._id === rolId);

			if (!roleToDuplicate) {
				this.error({ message: 'Role not found' });
				return;
			}

			const newRolName = `${roleToDuplicate.name}_copy`;
			this.createRole( {
				name: newRolName,
				description: roleToDuplicate.description,
				permissions: roleToDuplicate.permissions
			});
		},
		handleUpdateRole(role) {
			const roleId = role._id;
			delete role._id;

			this.updateRole({ id: roleId, role });
		}
	}
};
</script>
